<template>
  <section class="mx-10">
    <v-container> </v-container>

    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="6">
            <v-select
              v-if="years"
              v-model="selectedYear"
              :items="years"
              label="Улирал сонгоx"
              return-object
              item-text="name"
              item-value="id"
            >
            </v-select>
          </v-col>
          <v-col v-if="selectedYear">
            <v-text-field v-model="search" label="Xайx утга" clearable>
            </v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-progress-linear
        v-if="loading"
        color="blue"
        indeterminate
      ></v-progress-linear>
      <template v-else>
        <v-card-text>
          <v-row justify="end">
            <v-col>
              <h2>
                Бүртгэгдсэн дүн
                <span v-if="selectedYear && selectedYear.scores">({{
                  selectedYear.scores.length
                }})</span>
              </h2>
              <p>{{ zeroStudentCode }}</p>
            </v-col>
            <v-col class="text-end" v-if="selectedYear">
              <v-btn @click="_scoreZero('score30')" small color="#ececec"
                >О дүнтэй (30)</v-btn
              >
            </v-col>
            <v-col class="text-end" v-if="selectedYear">
              <v-btn color="#ececec" @click="_scoreZero('score70')" small
                >О дүнтэй (70)</v-btn
              >
            </v-col>
            <v-col class="text-end">
              <v-btn
                @click="_nextN(10)"
                small
                color="secondary"
                v-if="selectedYear"
                >Бүx дүнг дуудаx</v-btn
              >
            </v-col>
          </v-row>
          <template v-if="selectedYear&&selectedYear.scores">
            <v-data-table :headers="headers" :items="selectedYear.scores" :search="search"/>
          </template>
        </v-card-text>
      </template>
    </v-card>
  </section>
</template>

<script>
import { mapState } from "vuex";
const fb = require("@/firebaseConfig.js");

export default {
  data() {
    return {
      headers: [
        { text: 'index', value: 'index' },
        { text: 'Оюутны код', value: 'ref.path' },
        { text: 'Xичээлийн код', value: 'lessonCode' },
        { text: 'Семестер', value: 'semesterName' },
        { text: '30 Оноо', value: 'score30' },
        { text: '70 Оноо', value: 'score70' },
        { text: 'Эцсийн дүн', value: 'scoreTotal' },
 
      ],
      search: '',
      loading: false,
      selectedYear: null,
      activeTab: 0,
      years: null,
      lastDoc: null,
    };
  },
  components: {
    ...mapState(["userProfile", "currentUser"]),
  },
  computed: {
    zeroStudentCode() {
      if (this.selectedYear && this.selectedYear.scores)
        return (
          this.selectedYear.scores.length -
          this.selectedYear.scores.filter(
            (member) =>
              member.studentCode != undefined || member.studentCode != null
          ).length
        );
      else return 0;
    },
  },
  watch: {
    searchWord(val) {
      if (val && val.length > 0) {
        this.loading = true;
        this.selectedYear.ref
          .collection("yearScores") 
          .limit(500)
          .get()
          .then((docs) => {
            this.lastDoc = docs.docs[docs.docs.length - 1];
            this.selectedYear.scores = [];
            var counter = 0;
            docs.forEach((doc) => {
              counter++;
              let score = doc.data();
              score.id = doc.id;
              score.ref = doc.ref;
              score.name = doc.id;
              score.index = counter;
              this.selectedYear.scores.push(score);
            });
            this.loading = false;
          });
      }
    },
    selectedYear(val) {
      this.selectedYear.scores = null;
      this.loading = true;
      val.ref
        .collection("yearScores")
        .limit(500)
        .get()
        .then((docs) => {
          this.lastDoc = docs.docs[docs.docs.length - 1];
          this.selectedYear.scores = [];
          var counter = 0;
          docs.forEach((doc) => {
            counter++;
            let score = doc.data();
            score.id = doc.id;
            score.ref = doc.ref;
            score.name = doc.id;
            score.index = counter;
            this.selectedYear.scores.push(score);
          });
          this.loading = false;
        });
    },
  },
  methods: {
    _scoreZero(fieldName) {
      this.selectedYear.scores = null;
      this.loading = true;
      this.selectedYear.ref
        .collection("yearScores")
        .where(fieldName, "==", 0)
        .get()
        .then((docs) => {
          this.lastDoc = docs.docs[docs.docs.length - 1];
          this.selectedYear.scores = [];
          var counter = 0;
          docs.forEach((doc) => {
            counter++;
            let score = doc.data();
            score.id = doc.id;
            score.ref = doc.ref;
            score.name = doc.id;
            score.index = counter;
            this.selectedYear.scores.push(score);
          });
          this.loading = false;
        });
    },
    async _nextN(n) {
      console.log(n);
      for (var i = 0; i <= n; i++) {
        await this._next();
      }
    },
    async _next() {
      try {
        this.loading = true;
        await this.selectedYear.ref
          .collection("yearScores")
          .startAfter(this.lastDoc)
          .limit(500)
          .get()
          .then((nextQuerySnapshot) => {
            this.lastDoc =
              nextQuerySnapshot.docs[nextQuerySnapshot.docs.length - 1];
            var counter = this.selectedYear.scores.length;
            console.log(nextQuerySnapshot.docs.length);
            nextQuerySnapshot.forEach((doc) => {
              counter++;
              let score = doc.data();
              score.id = doc.id;
              score.ref = doc.ref;
              score.name = doc.id;
              score.index = counter;
              this.selectedYear.scores.push(score);
            });
            this.loading = false;
          })
          .catch((error) => {
            console.log("Error getting documents: ");
          });
      } catch (error) {
        console.log("ERROR");
        this.loading = false;
      }
    },
  },
  created() {
    fb.db
      .collection("/schools/YJHjHWUGDok8teDhDIKX/_allStudentsScores")
      .orderBy("createdAt", "desc")
      .get()
      .then((docs) => {
        this.years = [];
        docs.forEach((doc) => {
          let year = doc.data();
          year.id = doc.id;
          year.ref = doc.ref;
          year.name = doc.id;
          this.years.push(year);
        });
      });
  },
};
</script>